export const REGISTER_STEPS = {
  SIGN_IN_INFO: 'signInInfo',
  USER_INFO: 'userInfo',
  COMPANY_INFO: 'companyInfo',
  COMPANY_ADDRESS: 'companyAddress',
  COLLABORATORS: 'numberOfCollaborators',
  DISCOUNT: 'discount',
};

export const STEP_ORDER = [
  REGISTER_STEPS.SIGN_IN_INFO,
  REGISTER_STEPS.USER_INFO,
  REGISTER_STEPS.COMPANY_INFO,
  REGISTER_STEPS.COMPANY_ADDRESS,
  REGISTER_STEPS.COLLABORATORS,
  REGISTER_STEPS.DISCOUNT,
];
